import React from 'react';
import PropTypes from 'prop-types';
import { assign } from 'lodash';
import { Form } from 'react-bootstrap';

const StyleOpacityField = ({ alpha, updateAlpha, isLayerOpacity }) => {
  const rangeProps = {};
  if (isLayerOpacity) {
    assign(rangeProps, {
      min: 0,
      max: 100,
      step: 1,
      name: 'opacity'
    });
  } else {
    assign(rangeProps, {
      min: 0.01,
      max: 1,
      step: 0.01,
      name: 'alphaSelector'
    });
  }
  return (
    <Form.Group>
      <Form.Label>Opacity {isLayerOpacity && '(%)'}</Form.Label>
      <Form.Control
        type="range"
        key={`alpha-${alpha}`}
        defaultValue={alpha}
        onChange={updateAlpha}
        {...rangeProps}
      />
    </Form.Group>
  );
};

StyleOpacityField.defaultProps = {
  isLayerOpacity: false,
  updateAlpha: () => {}
};

StyleOpacityField.propTypes = {
  alpha: PropTypes.number.isRequired,
  updateAlpha: PropTypes.func,
  isLayerOpacity: PropTypes.bool
};

export default StyleOpacityField;
